import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Track from "@/pages/Track";
import Gift from "@/pages/Gift";
import Packages from "@/pages/Packages";
import Review from "@/pages/Review";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { ConciergeChat } from "@/components/ConciergeChat";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09, anchors: true });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book" element={<Booking />} />
          <Route path="/track" element={<Track />} />
          <Route path="/gift" element={<Gift />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/packages/:slug" element={<Packages />} />
          <Route path="/review" element={<Review />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
        <ConciergeChat />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121215",
            border: "1px solid rgba(212,175,55,0.25)",
            color: "#f4f4f6",
          },
        }}
      />
    </div>
  );
}

export default App;
